module.exports = __webpack_public_path__ + "assets/images/gender_male.cc2eeb67bdfef470ff392e1ada49602e.svg";